import React from "react";
import { Section, SectionHeading, SectionLabel } from "../ui";
import { CASE_STUDIES, FEATURED_STUDY } from "../content";

export default function CaseStudies() {
  return (
    <Section id="results" className="tw-scroll-mt-24 tw-bg-[#f4f8fc]">
      <div className="tw-grid tw-grid-cols-[.8fr_1.2fr] tw-items-end tw-gap-10 sm:tw-grid-cols-1">
        <div>
          <SectionLabel>Programmes we&rsquo;ve run</SectionLabel>
          <SectionHeading>Software plus programme know-how.</SectionHeading>
        </div>
        <p className="tw-m-0 tw-max-w-2xl tw-justify-self-end tw-text-lg tw-leading-8 tw-text-[#5b7188] sm:tw-justify-self-start">
          We&rsquo;ve supported organisations at different stages, from building a first programme to
          strengthening an existing one.
        </p>
      </div>

      <div className="tw-mt-12 tw-grid tw-grid-cols-2 tw-gap-4 sm:tw-grid-cols-1">
        <article className="tw-rounded-[28px] tw-bg-[#087bd3] tw-p-9 tw-text-white sm:tw-p-7">
          <p className="tw-m-0 tw-text-sm tw-font-bold tw-uppercase tw-tracking-[.14em] tw-text-white">
            {FEATURED_STUDY.name}
          </p>
          <p className="tw-mt-8 tw-mb-0 tw-text-5xl tw-font-black tw-tracking-[-.05em]">
            {FEATURED_STUDY.headline[0]}
            <br />
            {FEATURED_STUDY.headline[1]}
          </p>
          <p className="tw-mt-6 tw-mb-0 tw-max-w-lg tw-text-lg tw-leading-8 tw-text-white">
            {FEATURED_STUDY.body}
          </p>
        </article>

        <div className="tw-grid tw-gap-4">
          {CASE_STUDIES.map((study) => (
            <article
              key={study.name}
              className="tw-grid tw-grid-cols-[190px_1fr] tw-gap-6 tw-rounded-2xl tw-border tw-border-[#d4e2ee] tw-bg-white tw-p-6 xs:tw-grid-cols-1 xs:tw-gap-0"
            >
              <h3 className="tw-m-0 tw-font-black tw-text-[#1a3958]">{study.name}</h3>
              <p className="tw-m-0 tw-leading-7 tw-text-[#5b7188] xs:tw-mt-2">{study.body}</p>
            </article>
          ))}
        </div>
      </div>
    </Section>
  );
}
